const ZH_CN = {
  
}

export default ZH_CN;